import React from "react";

export default function ApprovedContractorsListItem({ approvedContractor }) {
  const companyAddress = approvedContractor.address + " " + approvedContractor.city + ", " + approvedContractor.state + " " + approvedContractor.zip
  const contractDate = new Date (approvedContractor.contractPopDate).toDateString();
  const contractDisplayDate = contractDate.substring(4, 10) + ", " + contractDate.substring(11);
  return (
    <tr role="row">
      <td className="sitenames" title={companyAddress} role="gridcell">
        {approvedContractor.name}
      </td>
      <td className="text-left" role="gridcell">
        {approvedContractor.federalContractNumber}
      </td>
      <td className="text-left" role="gridcell">
        {contractDisplayDate}
      </td>
      <td className="shortagencynames" title={approvedContractor.agencyName} role="gridcell">
        {approvedContractor.shortAgencyName}
      </td>
    </tr>
  );
}
